import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { HOME_FAQ } from "@/lib/usecases";
import { Plus, ArrowUpRight } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export default function HomeFaq() {
  const { t, lang } = useLang();
  const faq = HOME_FAQ[lang];

  const requestGuide = () => {
    window.dispatchEvent(
      new CustomEvent("berlincube:prefill-contact", {
        detail: { message: t.financing.funding.guideMessage, subject: "Förderleitfaden" },
      })
    );
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="faq" data-testid="section-home-faq" className="relative bg-[#16191D] py-28 md:py-40">
      <div className="max-w-[1000px] mx-auto px-6 md:px-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease }}
        >
          <div className="flex items-center gap-3 text-[11px] tracking-[0.4em] uppercase text-white/45 mb-8 font-display">
            <span className="h-px w-8 bg-[#B18B5E]" />
            {lang === "de" ? "Häufige Fragen" : "FAQ"}
          </div>
          <h2
            className="font-display font-light tracking-[-0.02em] leading-[1.05] text-white"
            style={{ fontSize: "clamp(1.75rem, 3.5vw, 2.8rem)" }}
            data-testid="home-faq-title"
          >
            {lang === "de" ? "Fragen aus Kommunen" : "Questions from municipalities"}
          </h2>
        </motion.div>

        <div className="mt-10 divide-y divide-white/10 border-b border-white/10">
          {faq.map((f, i) => (
            <details key={i} className="group py-5" data-testid={`home-faq-${i}`}>
              <summary className="flex items-start justify-between gap-6 cursor-pointer list-none text-white/85 hover:text-white transition-colors font-display font-light text-lg md:text-xl tracking-[-0.01em]">
                {f.q}
                <Plus className="mt-1.5 h-4 w-4 shrink-0 text-[#F5D77A]/60 transition-transform group-open:rotate-45" strokeWidth={1.5} />
              </summary>
              <p className="mt-4 text-white/65 leading-[1.7] text-[15px] md:text-base pr-10">{f.a}</p>
            </details>
          ))}
        </div>

        <button
          onClick={requestGuide}
          data-testid="home-faq-guide-cta"
          className="mt-10 group inline-flex items-center gap-3 text-[#F5D77A] hover:text-white transition-colors font-display text-sm tracking-[0.18em] uppercase"
        >
          {lang === "de" ? "Förderleitfaden anfordern" : "Request the funding guide"}
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
        </button>
      </div>
    </section>
  );
}
